export function getClusterScale(value: number): number {
    if (value < 50) {
        return 1;
    }

    if (value < 75) {
        return 1.05;
    }

    if (value < 100) {
        return 1.15;
    }

    if (value < 150) {
        return 1.2;
    }

    if (value < 250) {
        return 1.25;
    }

    return 1.325;
}
